import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "../../../../i18n/useTranslation";

const Markets = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="band-hero section text-center">
        <div className="eyebrow">{t("markets.eyebrow")}</div>
        <h1>{t("markets.headingLine1")}<br />{t("markets.headingLine2")}</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{t("markets.intro")}</p>
        </div>
      </div>

      <div className="band-a section">
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-5">
          <div className="card-ledger text-center">
            <span className="tag-verdigris">Parent · Global</span>
            <h3>Tapaswe Global</h3>
            <p className="mini">{t("markets.globalDesc")}</p>
            <Link to="/markets/global" className="btn-outline inline-block mt-2">{t("markets.globalBtn")}</Link>
          </div>
          <div className="card-ledger text-center">
            <span className="tag-verdigris">India · Bharat</span>
            <h3>Tapaswe Bharat</h3>
            <p className="mini">{t("markets.bharatDesc")}</p>
            <Link to="/markets/india" className="btn-outline inline-block mt-2">{t("markets.bharatBtn")}</Link>
          </div>
          <div className="card-ledger text-center">
            <span className="tag-verdigris">Market · US</span>
            <h3>Tapaswe USA</h3>
            <p className="mini">{t("markets.usaDesc")}</p>
            <Link to="/markets/usa" className="btn-outline inline-block mt-2">{t("markets.usaBtn")}</Link>
          </div>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 px-5 pt-8">
          <div className="card-ledger text-center opacity-60">
            <span className="tag-coming-soon">{t("markets.planned")}</span>
            <h3>Russia</h3>
            <p className="mini">{t("markets.plannedDesc")}</p>
          </div>
          <div className="card-ledger text-center opacity-60">
            <span className="tag-coming-soon">{t("markets.planned")}</span>
            <h3>Australia</h3>
            <p className="mini">{t("markets.plannedDesc")}</p>
          </div>
        </div>
      </div>

      <div className="band-b section-tight text-center">
        <ShieldCheck className="mx-auto" size={40} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
        <div className="eyebrow">{t("markets.sovereigntyEyebrow")}</div>
        <h2>{t("markets.sovereigntyHeading")}</h2>
        <div className="max-w-xl mx-auto pt-2">
          <p className="mini">{t("markets.sovereigntyBody")}</p>
        </div>
        <Link to="/data-sovereignty" className="btn-outline inline-block mt-4">{t("footer.dataSovereignty")}</Link>
      </div>
    </div>
  );
};

export default Markets;
